export default "__VITE_ASSET__CioLB8bH__"